/**
 * Renders the version bar for the forms that have one, and nothing for the
 * rest.
 *
 * Keeping the check here rather than in each card means adding a form to
 * `VERSIONED_FORM_BASE_IDS` in coms is enough to give it history and
 * signatures, with no card edit.
 */

import type React from 'react';
import type { ReactNode } from 'react';

import { useICSContext } from '../planningView/ICSContext';

import { isVersionedForm } from './formSectionSchema';
import FormVersioningPanel from './FormVersioningPanel';

export type FormVersioningBannerProps = {
  baseId: string;
  /**
   * Which chain of the form to show, for a form with more than one per period.
   * The 221 passes the resource's id; every other banner leaves this off.
   */
  formInstanceId?: string;
  /** Content shown alongside the bar, e.g. a caller-supplied notice. */
  children?: ReactNode;
};

export const FormVersioningBanner: React.FC<FormVersioningBannerProps> = ({
  baseId,
  formInstanceId,
  children,
}) => {
  const { effectivePeriodNumber, readOnlyForms } = useICSContext();

  if (!isVersionedForm(baseId)) return <>{children}</>;

  return (
    <>
      <FormVersioningPanel
        baseId={baseId}
        periodNumber={effectivePeriodNumber}
        readOnly={readOnlyForms}
        formInstanceId={formInstanceId}
      />
      {children}
    </>
  );
};

export default FormVersioningBanner;
